














































import { Component, Prop, Vue } from 'vue-property-decorator';
import { IUser } from '@/interfaces/user';
import { IGroup } from '../../interfaces/group';
import CreateDeviceMutation from '@/graphql/mutations/createDevice.gql';
import request from '@/graphql/request';

@Component({
  components: {
  },
})
export default class GroupAddGroup extends Vue {
  @Prop({ required: true })
  public group!: IGroup;

  public nickname: string = '';
  public deviceTag: string = '';

  

  public async createDevice() {
    const { data, errors } = await request(CreateDeviceMutation, {
      nickname: this.nickname,
      deviceTag: this.deviceTag,
      groupId: this.group.id,
    });

    if (!errors || !errors.length) {
      this.$router.push(`/group/${this.group.id}/devices`);
      this.$emit('refreshGroup');
    }
  }
}
